<h1 matDialogTitle>
	<div class="flex items-center">
		<div>{{ 'reports.export' | translate }}</div>
		<div class="flex-auto"></div>
		<div class="flex items-center space-x-2">
			<button
				[disabled]="closeDisabled"
				mat-icon-button
				matDialogClose
				tabindex="-1"
			>
				<mat-icon>close</mat-icon>
			</button>
		</div>
	</div>
</h1>
<mat-dialog-content cdkTrapFocus>
	<form
		(submit)="$event.preventDefault()"
		[formGroup]="this.group"
		class="mb-3"
	>
		<div class="flex flex-col items-stretch justify-start gap-2">
			<div class="flex flex-col gap-1">
				<div class="mat-typography mat-hint">{{ "reports.exports.type" | translate }}</div>
				<mat-radio-group
					class="file-type-group grid grid-cols-1 gap-2 mb-4 sm:grid-cols-2"
					formControlName="type"
				>
					<mat-radio-button
						[class.file-type-option--active]="group.value.type === fileType.value"
						[value]="fileType.value"
						*ngFor="let fileType of fileTypeOptions"
						class="file-type-option"
					>
						<div class="file-type-option__content">
							<div class="file-type-option__left">
								<div class="file-type-option__icon-wrap">
									<mat-icon class="file-type-option__icon">{{ fileType.icon }}</mat-icon>
								</div>
								<div class="flex flex-col leading-tight">
									<span class="font-medium">{{ fileType.title }}</span>
									<span class="mat-hint text-xs">{{ fileType.description }}</span>
								</div>
							</div>
							<div
								*ngIf="group.value.type === fileType.value"
								class="file-type-option__active-indicator"
							>
								<mat-icon>check</mat-icon>
							</div>
						</div>
					</mat-radio-button>
				</mat-radio-group>
			</div>
			<mat-form-field appearance="fill">
				<mat-label>{{ "workspace.timecontingent.showUntil" | translate }}</mat-label>
				<input
					[matDatepicker]="cutOffDatePicker"
					[max]="maxCutOffDate"
					formControlName="cutOffDate"
					matInput
				>
				<mat-datepicker-toggle
					[for]="cutOffDatePicker"
					matSuffix
				></mat-datepicker-toggle>
				<mat-datepicker #cutOffDatePicker></mat-datepicker>
			</mat-form-field>
		</div>

		<!-- <div class="flex items-center mb-1 gap-2">
      <mat-slide-toggle formControlName="userWithOutStart" color="primary"></mat-slide-toggle>
      <span class="ml-0.5">
        {{ 'reports.exports.userWithoutStart' | translate }}
      </span>
    </div> -->

		<!-- <div class="flex flex-col pb-5" *ngIf="group.value.type === 'excel'">
      <mat-form-field appearance="fill" class="mat-form-field-inline">
        <mat-label>{{ 'reports.export-columns.label' | translate }}</mat-label>
        <mat-select formControlName="columnType">
          <mat-option [value]="0">{{ 'reports.export-columns.all' | translate }} ({{ exportColumns.length }})</mat-option>
          <mat-option [value]="1">{{ 'reports.export-columns.custom' | translate }} ({{ selectedExportColumns$ | async }})</mat-option>
        </mat-select>
      </mat-form-field>
      <div class="rounded-bottom grid grid-cols-1 gap-1 bg-neutral-500/10 px-3.5 pb-4 pt-2 dark:bg-black/10 md:grid-cols-2 lg:grid-cols-3" *ngIf="group.value.columnType === 1" formGroupName="columns">
        <ng-container *ngFor="let col of exportColumns">
          <mat-checkbox [formControlName]="col" color="primary" class="mat-checkbox-truncate mat-checkbox-flex">
            <span class="truncate">{{ 'reports.export-column.' + col | translate }}</span>
          </mat-checkbox>
        </ng-container>
      </div>
    </div> -->
	</form>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<ng-container
		*ngTemplateOutlet="!(loading$.value$ | async) ? submitButton : submitWaitButton; context: { disabled: group.invalid || group.disabled }"
	></ng-container>
</mat-dialog-actions>
<ng-template
	#submitButton
	let-disabled="disabled"
>
	<button
		(click)="submit()"
		[disabled]="disabled"
		color="primary"
		mat-flat-button
	>
		{{ 'utils.download' | translate }}
	</button>
</ng-template>
<ng-template #submitWaitButton>
	<button
		[disabled]="true"
		color="primary"
		mat-flat-button
	>
		<div class="flex items-center justify-center space-x-2">
			<mat-spinner
				[diameter]="16"
				[strokeWidth]="2"
				mode="indeterminate"
			></mat-spinner>
			<span>{{ 'utils.download' | translate }}</span>
		</div>
	</button>
</ng-template>
